import Layout from "@/components/Layout";
import "@/styles/globals.css";
import { useAuthentication } from "@/utils/auth";
import { getPageName } from "@/utils/pageName"; // Import the utility function
import { heading, sans, serif } from "@/utils/typography"; // Import fonts
import type { AppProps } from "next/app";
import { useRouter } from "next/router";

export default function App({ Component, pageProps }: AppProps) {
  const { isAuthenticated, isClient } = useAuthentication();
  const router = useRouter();

  if (!isClient || !isAuthenticated) {
    return null; // Hide everything until authenticated and client-side rendering is confirmed
  }

  const pageName = getPageName(router.pathname); // Use the utility function

  return (
    <main
      className={`${serif.variable} ${sans.variable} ${heading.variable} ${pageName}`}
    >
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </main>
  );
}
